import { render, staticRenderFns } from "./collectlist.vue?vue&type=template&id=2a632f8b&scoped=true"
import script from "./collectlist.vue?vue&type=script&lang=js"
export * from "./collectlist.vue?vue&type=script&lang=js"
import style0 from "./collectlist.vue?vue&type=style&index=0&id=2a632f8b&prod&scoped=scoped&lang=css"
import style1 from "./collectlist.vue?vue&type=style&index=1&id=2a632f8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a632f8b",
  null
  
)

export default component.exports